import React from 'react';
import { Row, Col, FormGroup, Button } from 'react-bootstrap';
import * as Modals from 'fw/globals/Modals';
import { DocumentUpload } from "areas/shared/controls";
import * as API from 'modules/app/API'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

class SponsorDocumentsGrid extends React.Component {

    constructor(props) {
		super(props);

		this.state = {
            documents: this.props.documents
        }        
    }
    
    componentDidMount() {
        if (this.state.documents === null || this.state.documents.length === 0) {
			this.addReviewDocument();
		}
    }

    handleAdd = (document, index) => {

        if (!document || document.fileName == null)
            return;

        let documents = this.state.documents;

        const rq = {
            sponsorId: this.props.sponsorId,
            storageToken: document.storageToken,
            fileName: document.fileName
		};

		API.Sponsor.post('/sponsorSetup/addReviewDocument', rq, {
			success: (sr) => {
                documents[index].storageToken = document.storageToken;
                documents[index].fileName = document.fileName;
                documents[index].reviewDocumentId = sr.data.reviewDocumentId;
				documents[index].addedDate = sr.data.addedAt;
				documents[index].addedBy = sr.data.addedBy;

                this.setState({ documents: documents });

                if(this.props.onUploadDocument)
                    this.props.onUploadDocument("<b class='text-primary'>Document Uploaded:</b> "+document.fileName, "DA");
			}
		});
    }

    handleDelete = (index) => {
            
        let document = this.state.documents[index];

		Modals.remove({
			title: "Removing document",
			elementType: "document",
			name: document.fileName,
			reason: true,
			onYes: (id, reason) => {
                
                const rq = {
                    reviewDocumentId: document.reviewDocumentId,
                    entityId: this.props.entityId,
                    reason: reason
                };
        
                API.Sponsor.post('/sponsorSetup/deleteReviewDocument', rq, {
                    success: (sr) => {
                        let documents = this.state.documents;
                        documents = documents.filter(x => x.reviewDocumentId !== document.reviewDocumentId);

                        this.setState({ documents: documents });

                        if(this.props.onUploadDocument)
                            this.props.onUploadDocument("<b class='text-primary'>Document Removed:</b> "+document.fileName+" - "+reason, "DR");
                    }
                });
            },
            onNo: () => {
                // To set again the upload control that was cleared on click
                let documents = this.state.documents;
                this.setState({ documents: documents });
            }
		});
	}

    addReviewDocument = () => {
        let documents = this.state.documents;
        documents.push({});

        this.setState({ documents: documents })
    };

    removeReviewDocument = (index) => {
        let documents = this.state.documents;
        documents.splice(index, 1);
        
        this.setState({ documents: documents })
    }

    renderReviewDocuments = () => {
        var me = this;
        return this.state.documents.map((item, index) => (
            <Row key={index}>
                <Col md={item.fileName == null ? 11 : 12}>
                    <DocumentUpload 
                        disabled={me.props.readonly}
                        storageToken={item.storageToken}
                        fileName={item.fileName}
                        onChange={file => this.handleAdd(file, index)}
                        onRemove={() => this.handleDelete(index)}
                        skipConfirmation={true}
                        wrapFileNameLength={30}
                    />
                </Col>
                {!me.props.readonly && item.fileName == null && 
                <Col md={1} style={{ textAlign: "left", marginTop: 5, marginLeft: -15, paddingLeft: 0 }}>
					<Button type="button" bsStyle="link" onClick={() => this.removeReviewDocument(index)} title="Remove Sponsor Document">
                        <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
					</Button>
                </Col>
                }
            </Row>
        ));
    };

    render() {
        return (
            <React.Fragment>
                {this.state.documents != null && this.state.documents.length > 0 && (
                    <FormGroup>
                        {this.renderReviewDocuments()}
                    </FormGroup>
                )}
                {!this.props.readonly &&
					<Button type="button" bsStyle="link" onClick={this.addReviewDocument}>
						Add another Document
					</Button>
				}
            </React.Fragment>
        )
    }
}

export default SponsorDocumentsGrid;



// WEBPACK FOOTER //
// ./src/areas/shared/components/sponsorDocumentsGrid/SponsorDocumentsGrid.js